import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';
import { throwErrorWithId } from '@pypestream/utils';

import { checkForErrors, getPypeRuleGroups, type RuleSet } from '../../utils';
import { ProStudioContext, ProStudioEvents } from '../prostudio.xstate.types';

/**
 * Updates a rule set. All rule-level edits (add/edit/delete a rule) flow through
 * here via `rulesToAdd` / `rulesToUpdate` / `rulesToDelete`; `name` is always
 * sent (backend requires it) so a rule-only change re-sends the current name.
 */
export const updatePypeRuleGroup = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<{ pypeRuleGroups: RuleSet[]; cb?: () => void } | void> => {
  if (event.type !== 'updatePypeRuleGroup') {
    return;
  }

  const projectId = ctx.project?.id;

  if (!projectId) {
    throwErrorWithId('Project ID is required');
    return;
  }

  const {
    id,
    name,
    description,
    rulesToAdd,
    rulesToUpdate,
    rulesToDelete,
    cb,
  } = event.payload;

  const response = await urqlGql.updatePypeRuleGroup({
    id,
    name,
    description,
    rulesToAdd,
    rulesToUpdate,
    rulesToDelete,
  });
  checkForErrors(response);

  const pypeRuleGroups = await getPypeRuleGroups({ projectId });

  return { pypeRuleGroups, cb };
};
